<template>
	<div class="classificationBox">
		<el-button size="medium" type="primary" @click="adddialogVisible()">{{$t('QuesLibrary.Tambah')}}</el-button>

		<div class="type flex" v-for="(item, index) in typeList" :key="item.id">
			<p @click="dataAll()">{{ item.questionnaireTypeName }}</p>
			<ul class="flex type-ul">
				<li :class="{ typeActive: typeId == 0 ? 'typeActive' : '' }" @click="typeClick('', '', '')">{{$t('QuesLibrary.All')}}</li>
				<li
					:class="{
						typeActive: typeId == item.id ? 'typeActive' : ''
					}"
					v-for="(item, secondIndex) in item.questionnaireTypeList"
					:key="item.id"
					@click="typeClick(index, secondIndex, item.id)"
				>
					{{ item.questionnaireTypeName }}
				</li>
			</ul>
		</div>

		<el-table :data="tableData" border style="width: 100%">
			<el-table-column align="center" fixed prop="wjTitle" :label="$t('QuesLibrary.QuestionnaireName')"></el-table-column>
			<el-table-column align="center" prop="refNumbers" :label="$t('QuesLibrary.NumberOfCitations')"></el-table-column>
			<el-table-column align="center" prop="typeName" :label="$t('QuesLibrary.Type')"></el-table-column>

			<el-table-column align="center" fixed="right" :label="$t('QuesLibrary.Operate')" width="200">
				<template slot-scope="scope">
					<el-link type="primary" :underline="false" @click="designTempPaper(scope.row.id)">{{$t('QuesLibrary.DesignQuestionnaire')}}</el-link>
					<el-link type="primary" :underline="false" @click="previewClick(scope.row.id)">{{$t('QuesLibrary.Preview')}}</el-link>
					<el-popconfirm style="margin-left: 10px;" :title="$t('QuesLibrary.AreYouSureToDeleteIt')" @confirm="delTempPaper(scope.row.id)">
						<el-link type="primary" :underline="false" slot="reference">{{$t('QuesLibrary.Delete')}}</el-link>
					</el-popconfirm>
					<el-link type="primary" :underline="false" @click="editTempPaper(scope.row)" style="margin-left: 10px;">{{$t('QuesLibrary.Modify')}}</el-link>
				</template>
			</el-table-column>
		</el-table>

		<el-dialog :title="title" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" :close-on-click-modal="false">
			<div>
				<el-input size="medium" v-model="tempPaperObj.title" :placeholder="$t('QuesLibrary.Name')" clearable :maxlength="50"></el-input>
				<el-cascader size="medium" v-model="tempPaperObj.Types" style=" width: 100%; margin: 20px 0px;" :options="options" :props="props" collapse-tags clearable></el-cascader>

				<el-upload
					class="avatar-uploader"
					ref="upload"
					:action="$config.service.uploadApi"
					:show-file-list="false"
					:on-success="handleSuccess"
					:before-upload="beforeAvatarUpload"
					:data="QiniuData"
					:on-remove="handleRemove"
					:multiple="false"
					:limit="1"
					accept="image/jpg,image/jpeg,image/png"
				>
					<!-- <el-button type="primary" size="small">本地上传</el-button> -->
					<img v-if="uploadPicUrl" :src="uploadPicUrl" class="avatar" />
					<i v-else class="el-icon-plus avatar-uploader-icon" style="border:1px solid #ccc"></i>
				</el-upload>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="dialogVisible = false">{{$t('main.cancel2')}}</el-button>
				<el-button size="medium" type="primary" @click="dialogOk()">{{$t('main.ok2')}}</el-button>
			</span>
		</el-dialog>
		
		<!-- <el-dialog class="test-box" title="设计问卷" :fullscreen="true" :visible.sync="questionstypeVisible" width="30%" :before-close="handleClose" :close-on-click-modal="false">
			<div class="page-header">
			    <el-page-header @back="goBack" content="系统模板 - 设计文件">
			    </el-page-header>
			</div>
			<Questionstype @closeQuestionstype="closeQuestionstype" :isTemplate="true">
				
			</Questionstype>
		</el-dialog> -->
		
		<div class="AddTestQuestions" v-if="questionstypeVisible">
		    <div class="page-header">
		        <el-page-header @back="goBack" :content="`${$t('QuesLibrary.TemplatSistem')} - ${$t('QuesLibrary.DesignQuestionnaire')}`">
		        </el-page-header>
		    </div>
		    <div class="body">
		        <Questionstype @closeQuestionstype="closeQuestionstype" :isTemplate="true">
		        	
		        </Questionstype>
		    </div>
		</div>
		
		
	</div>
</template>

<script>
import Questionstype from '../myQuestionnaire/Questionstype.vue';
import { mapState } from 'vuex';
export default {
	name: 'AddQuestionnaire',
	components: {
		Questionstype
	},
	data() {
		return {
			questionstypeVisible: false,
			typeId: '',
			QiniuData: {
				biz: 'upDataWj',
				data: {}
			},
			uploadPicUrl: '',
			options: [],
			props: { multiple: true, value: 'id', label: 'questionnaireTypeName', children: 'questionnaireTypeList' },
			type1: '0-0',
			type2: '1-0',
			typeList: [],
			tempPaperObj: {
				title: '',
				Types: ''
			},
			addEditType: 1, //1添加 2编辑
			title: this.$t('QuesLibrary.Tambah'),
			dialogVisible: false,
			tableData: []
		};
	},
	computed: {
		...mapState(['headers'])
	},
	created() {
		this.loadType();
	},
	methods: {
		goBack() {
		    this.questionstypeVisible = false
		},
		previewClick(id) {
			this.$router.push({
				path: '/preview',
				query: { tabPosition: 'computer', id: id }
			});
		},
		dataAll() {
			this.typeId = '';
			this.loadData();
		},
		closeQuestionstype(state) {
			this.questionstypeVisible = state;
		},
		designTempPaper(id) {
			sessionStorage.setItem('wid', id);
			this.questionstypeVisible = true;
			// console.log(id)
			// this.$message.success(id);
			// setTimeout(() => {
			// 	this.$router.replace({ path: "/wjedit1", query: { id: 1 } });
			// }, 400);
		},
		handleRemove() {
			this.uploadPicUrl = '';
		},
		handleSuccess(res) {
			this.uploadPicUrl = res.message;
			// TODO: 上传成功后清理缓存，否则会导致头像无法上传
			this.$refs.upload.clearFiles();
		},
		beforeAvatarUpload(file) {
			let size = file.size < 1024 * 1024 * 5;
			if (!size) {
				this.$message({
					message: this.$t('QuesLibrary.CannotExceed5MB'),
					type: 'warning'
				});
				return size;
			}
			this.QiniuData.data = file;
		},
		dialogOk() {
			if (this.tempPaperObj.title == '') {
				this.$message.warning(this.$t('QuesLibrary.PleaseEnterAName'));
				return false;
			}
			if (this.tempPaperObj.Types == '') {
				this.$message.warning(this.$t('QuesLibrary.PleaseSelectCategory'));
				return false;
			}
			if (this.uploadPicUrl == '') {
				this.$message.warning(this.$t('QuesLibrary.PleaseUploadPictures'));
				return false;
			}
			let that = this;
			let tempList = [];
			that.tempPaperObj.Types.forEach(item => {
				tempList.push(item[1]);
			});

			let data = {
				wjTitle: that.tempPaperObj.title,
				idss: that.tempPaperObj.Types,
				pictureAddress: that.uploadPicUrl,
				ids: tempList,
				isSys: 1
			};
			if (that.tempPaperObj.id) {
				data.id = that.tempPaperObj.id;
			}
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.tempPaperSaveAndUpdate}`,
				data: data,
				cb(res) {
					if (res.code == 0) {
						that.$message.success(res.message);
						that.loadData();
						that.dialogVisible = false;
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		editTempPaper(data) {
			this.title = this.$t('QuesLibrary.Edit');
			this.addEditType = 2;
			this.dialogVisible = true;
			console.log(data);
			let tempPaperObj = JSON.parse(JSON.stringify(data));
			this.tempPaperObj = {
				title: tempPaperObj.wjTitle,
				Types: JSON.parse(tempPaperObj.idss),
				pictureAddress: tempPaperObj.pictureAddress,
				id: tempPaperObj.id
			};
			this.uploadPicUrl = this.tempPaperObj.pictureAddress;
		},
		adddialogVisible() {
			this.title = this.$t('QuesLibrary.Tambah');
			this.addEditType = 1;
			this.dialogVisible = true;

			(this.tempPaperObj = {
				title: '',
				Types: ''
			}),
				(this.uploadPicUrl = '');
		},

		delTempPaper(id) {
			console.log(id);
			let that = this;
			let params = {
				that: this,
				method: 'GET',
				url: `${this.$config.service.tempPaperDel}?id=${id}`,
				params: {
					id: id
				},
				cb(res) {
					if (res.code == 0) {
						that.$message.success(res.message);
						that.loadData();
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		handleClose(done) {
			done();
		},
		loadData() {
			let that = this;
			let params = {
				that: this,
				method: 'GET',
				url: `${this.$config.service.tempPaperList}?typeId=${that.typeId}&isSys=1`,
				data: {
					pageIndex: this.pageIndex,
					pageSize: this.pageSize
				},
				cb(res) {
					if (res.code == 0) {
						console.log();
						res.resultBody.datas.forEach(item => {
							item.typeName = item.typeName.toString();
						});
						that.tableData = res.resultBody.datas;
						// that.total = res.resultBody.total;
					} else {
						that.tableData = [];
					}
				}
			};
			params.isnologin = true;
			this.$util.request(params);
		},
		typeClick(index, second, id) {
			if (index == 0) {
				this.type1 = index + '-' + second;
				this.type2 = '1-0';
			} else {
				this.type1 = '0-0';
				this.type2 = index + '-' + second;
			}
			this.typeId = id;
			this.loadData();
		},
		loadType() {
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.queryquestionnairetype,
				data: {},
				cb(res) {
					if (res.code == 0) {
						// requestUtil

						that.typeList = res.resultBody.datas;
						console.log(that.typeList);
						that.typeId = '';
						console.log(that.typeId);
						that.options = res.resultBody.datas;
						that.loadData();
					} else {
						that.typeList = [];
						that.$message.error(res.message);
					}
				}
			};
			params.isnologin = true;
			this.$util.request(params);
		}
	}
};
</script>

<style lang="scss" scoped>
.typeActive {
	color: #0080ff;
}
.type {
	flex-shrink: 0;
	margin-top: 15px;
}
.type:first-child {
	margin-top: 40px;
}
.type p {
	font-size: 14px;
	color: #000;
	flex-shrink: 0;
	line-height: 40px;
}
.typeActive {
	color: #0080ff !important;
}
.type ul li {
	font-size: 14px;
	color: #000;
	margin-left: 30px;
	cursor: pointer;
	margin-bottom: 10px;
}
.type-ul {
	flex-wrap: wrap;
	margin-top: 10px;
}
.classificationBox {
	padding: 24px;
}
.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.avatar-uploader .el-upload:hover {
	border-color: #409eff;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 178px;
	line-height: 178px;
	text-align: center;
}
.avatar {
	width: 178px;
	height: 178px;
	display: block;
}
.test-box /deep/.el-dialog__body {
	background-color: #f1f1f1;
}
.test-box /deep/.el-dialog__header {
	padding: 20px;
}

.AddTestQuestions{
	width: 100%;
    height: 100%;
    background-color: #fff !important;
	position: fixed;
	top: 0px;
	left:0px;
	z-index:2000;
    .page-header{
        padding: 20px;
        background-color: rgb(255, 255, 255);
    }
    .form-box{ 
        width: 600px;
        margin: 40px auto 0 auto;
        .title{
            font-size: 16px;
            margin: 0 0 40px 30px;
        }
    }
    .body{
    }
}
</style>
